import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister, objectKlassEquals } from '@lexical/utils'
import {
    $createTabNode,
    $getSelection,
    $isRangeSelection,
    COMMAND_PRIORITY_LOW,
    PASTE_COMMAND,
} from 'lexical'
import { useEffect } from 'react'

export const PlainTextPastePlugin = () => {
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        return mergeRegister(
            editor.registerCommand(
                PASTE_COMMAND,
                (event) => {
                    if (objectKlassEquals(event, ClipboardEvent)) {
                        const clipboardEvent = event as ClipboardEvent
                        const text =
                            clipboardEvent.clipboardData.getData('text/plain')
                        if (text != null) {
                            const selection = $getSelection()
                            if ($isRangeSelection(selection)) {
                                const parts = text.split(/(\r?\n|\t)/)
                                if (parts[parts.length - 1] === '') {
                                    parts.pop()
                                }
                                for (let i = 0; i < parts.length; i++) {
                                    const part = parts[i]
                                    if (part === '\n' || part === '\r\n') {
                                        selection.insertLineBreak()
                                    } else if (part === '\t') {
                                        selection.insertNodes([
                                            $createTabNode(),
                                        ])
                                    } else {
                                        selection.insertText(part)
                                    }
                                }
                            }
                        }
                        return true
                    }
                    return false
                },
                COMMAND_PRIORITY_LOW,
            ),
        )
    }, [editor])

    return null
}
